// extracted by mini-css-extract-plugin
export var black = "_f-6";
export var brand = "_f-1";
export var ddefault = "_f-0";
export var error = "_f-3";
export var gray = "_f-2";
export var highContrast = "_f-8";
export var outline = "_f-7";
export var success = "_f-5";
export var warning = "_f-4";